import { useQuery } from "@tanstack/react-query";
import { weddingPackageName } from "@/lib/timelineDisplay";
import type { PackageRowLike, WeddingPackageRef } from "@shared/weddingPackage";

/**
 * The wedding's package name for the timeline screens — weddings.package_id first, via the
 * same shared resolver the server's timeline generator uses (review gap G7). Reads the
 * public, cached /api/packages list (same cache entry as dashboard/admin-users).
 */
export function useWeddingPackageName(wedding: WeddingPackageRef | null | undefined): string | null {
  const { data } = useQuery<PackageRowLike[]>({ queryKey: ["/api/packages"], staleTime: 60 * 60 * 1000 });
  return weddingPackageName(wedding, Array.isArray(data) ? data : []);
}
